import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[HJSuppress]',
  standalone: false,
})
export class HotjarSuppressDirective {
  constructor(private el: ElementRef) {
    this.el.nativeElement.classList.add('data-hj-suppress');
  }
}
